import {
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import React from "react";
import { StaticDatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import StepperGuide from "src/components/StepperGuide";
import TimezonePicker from "../../timezone-picker";
import Timezone from "src/utils/Timezone";
import TreffasStyle from "src/utils/TreffasStyle";
import { ArrowDropDown } from "@mui/icons-material";
import TreffasTextField from "src/components/TreffasTextField";
import { useDateAndTimePicker } from "src/views/hooks/useDateAndTimePicker";

const DateAndTime = ({
  selectedTimezone,
  setSessionSelectedTime,
  selectedOffer,
  setSessionList,
  selectedDate,
  setSelectedDate,
  setError,
  clearErrors,
  calendarMaxDate,
  userDateFormat,
  stepperGuideLength,
  bookingInfo,
  setAllUpcommingAppt,
  nextButtonRef,
  coachDetails,
  setOverFlowTimeToRender,
  setSelectedTimezone,
  setUnderFlowTimeToRender,
  isUseTimeRecord,
  setIsUseTimeRecord,
  timeRecords,
  setTimeRecords,
  preparingSessionList,
  setPreparingSesisonList,
  setActiveStep,
}) => {
  const { t } = useTranslation();
  const {
    shouldDisabledDate,
    handleSelectedDate,
    handleTimezoneChange,
    handleMonthChange,
    openTimezoneDialog,
    closeTimezoneDialog,
    timezoneDialog,
    datePickerMinDate,
    datePickerMaxDate,
    pickerValue,
  } = useDateAndTimePicker({
    selectedOffer,
    coachDetails,
    selectedTimezone,
    selectedDate,
    setSelectedDate,
    setSelectedTimezone,
    setSessionList,
    setSessionSelectedTime,
    setOverFlowTimeToRender,
    setUnderFlowTimeToRender,
    setAllUpcommingAppt,
    isUseTimeRecord,
    setIsUseTimeRecord,
    timeRecords,
    setTimeRecords,
    preparingSessionList,
    setPreparingSesisonList,
    clearErrors,
    calendarMaxDate,
    excludeAppointmentId: bookingInfo?.id,
    userDateFormat,
    setError,
    mode: "mobile",
    setActiveStep,
    afterDateLoaded: (data) => {
      if (!data?.is_full) {
        nextButtonRef?.current?.click();
      }
    },
  });

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            pt: "58px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "var(--font-grenettepromedium)",
                fontSize: "18px",
                lineHeight: "31px",
                alignItems: "center",
                color: "#060A2D",
              }}
            >
              Choose Schedule
            </Typography>

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "18px",
                color: "#878787",
                mt: "4px",
              }}
            >
              Select date and time for your {selectedOffer?.name} that works for
              you
            </Typography>
          </Box>

          <Box>
            <StepperGuide length={stepperGuideLength} activeLength={[1]} />
          </Box>
        </Box>
      </Box>

      <Box my={"20px"}>
        <Box mb={"10px"}>
          <Typography
            sx={{
              fontFamily: "var(--font-grenettepromedium)",
              fontSize: "10px",
              lineHeight: "11px",
              letterSpacing: "0.07em",
              color: "#A1A1A1",
              textTransform: "uppercase",
            }}
          >
            {t("booking.label.select_timezone")}
          </Typography>
        </Box>

        <Box sx={{ px: "5px" }}>
          <Box>
            <TreffasTextField
              value={Timezone.getLabel(selectedTimezone) ?? ""}
              sx={TreffasStyle.formInputLarge("autocomplete")}
              placeholder={t("booking.placeholder.select_timezone")}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      size={"small"}
                      onClick={() =>
                        openTimezoneDialog({ resetSelectedDate: true })
                      }
                    >
                      <ArrowDropDown />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box>
              <TimezonePicker
                dialog={timezoneDialog}
                close={closeTimezoneDialog}
                selectedTimezone={selectedTimezone}
                onChange={handleTimezoneChange}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: "48px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: "10px", md: "32px" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box className="new-static-calendar">
            <StaticDatePicker
              // disablePast
              minDate={datePickerMinDate}
              displayStaticWrapperAs="desktop"
              value={pickerValue}
              shouldDisableDate={shouldDisabledDate}
              onChange={handleSelectedDate}
              onMonthChange={handleMonthChange}
              renderInput={(params) => <TextField {...params} />}
              views={["day"]}
              inputFormat={userDateFormat}
              maxDate={datePickerMaxDate}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DateAndTime;
